/* eslint-disable no-shadow */
import { VISITS_SET } from './action-modulation.type';

export const state = {
  visits: [],
};

export const actions = {
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [VISITS_SET](state, visits) {
    state.visits = visits;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/dashboard.module.js